var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoLightGreen = function SvgLogoLightGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 61,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-light-green_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2FFEA",
    d: "M8.864 20.589c.394-9.538 9.568-16.82 19.66-13.96a14.79 14.79 0 0 1 10.153 10.136 15.386 15.386 0 0 1-11.705 19.53c-.117.022-.277.056-.395.074a6 6 0 0 1-1.014.082H9.61a1.608 1.608 0 0 1-1.206-2.675l.512-.585a3.23 3.23 0 0 0 .78-1.613 4.4 4.4 0 0 0 0-1.734 38.5 38.5 0 0 1-.832-9.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.998 33.243A12.208 12.208 0 0 0 32.274 22.08a11.84 11.84 0 0 0-8.111 8.107 12.304 12.304 0 0 0 9.373 15.607c.09 0 .216.047.312.06q.402.07.81.07h12.75a1.3 1.3 0 0 0 .967-2.142l-.434-.468a2.65 2.65 0 0 1-.624-1.3 3.6 3.6 0 0 1 0-1.37c.523-2.44.749-4.933.672-7.427zM69.012 11.983h4.213v30.433h-4.213zM77.248 33.443q0-2.77 1.248-4.877a8.95 8.95 0 0 1 3.473-3.278q2.184-1.21 4.955-1.21t4.916 1.21a8.95 8.95 0 0 1 3.472 3.278q1.288 2.106 1.288 4.877 0 2.73-1.288 4.877a9.24 9.24 0 0 1-3.472 3.316q-2.146 1.17-4.916 1.17t-4.955-1.17a9.24 9.24 0 0 1-3.473-3.316q-1.248-2.147-1.248-4.877m4.33 0q0 1.677.703 2.965a5.4 5.4 0 0 0 1.912 1.99q1.209.702 2.73.702 1.484 0 2.693-.702a5.3 5.3 0 0 0 1.95-1.99q.703-1.288.703-2.965 0-1.678-.702-2.966a4.95 4.95 0 0 0-1.951-1.99q-1.21-.702-2.692-.702-1.522 0-2.731.702-1.21.703-1.912 1.99-.703 1.288-.703 2.966M100.598 11.983h4.214v30.433h-4.214zM123.7 51V24.469h4.252V51zm-14.866-17.557q0-3.004 1.21-5.112 1.21-2.106 3.199-3.199A8.76 8.76 0 0 1 117.574 24q2.302 0 3.98 1.171 1.677 1.132 2.614 3.238.936 2.107.936 5.034 0 2.886-.936 5.033-.936 2.106-2.614 3.277-1.678 1.132-3.98 1.132a9 9 0 0 1-4.331-1.093q-1.99-1.132-3.199-3.238-1.21-2.146-1.21-5.111m4.37 0q0 1.794.741 3.082.742 1.249 1.951 1.912a5.94 5.94 0 0 0 2.692.624q1.21 0 2.38-.624 1.21-.663 1.951-1.912.781-1.248.781-3.082t-.781-3.083q-.74-1.248-1.951-1.873-1.17-.663-2.38-.663-1.443 0-2.692.663-1.209.625-1.951 1.912-.741 1.249-.741 3.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.684 13.024c0-.486 0-.728.094-.914a.87.87 0 0 1 .379-.379c.186-.094.428-.094.914-.094h19.422v2.948c0 .485 0 .728-.095.913a.87.87 0 0 1-.379.38c-.185.094-.428.094-.914.094H60.684z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-light-green_svg__a",
    width: 136,
    height: 64,
    x: 0,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2124_11168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2124_11168",
    result: "shape"
  })))));
};
export default SvgLogoLightGreen;